import "@/welcome.js";

document.addEventListener('livewire:navigating', () => {
  window.mobileNavigationLoaded=false
  window.desktopNavigationLoaded=false
  window.gamesMegaTabsLoaded=false
  window.headerScrollLoaded=false
  document.body.classList.remove('drawer-open');
  document.body.classList.remove('header-search-open');
  window.toastLoaded = false
  window.hoverLoaded = false
  window.dialogLoaded = false
  window.cartDropDownLoaded = false
  window.cartDropDownLoaded = false
  window.themeSwitchLoaded = false
  window.chatLoaded = false
  window.iconsLoaded = false
  window.initText = false
  window.iconsLoaded = false;
  removeAllListeners();
});


// رجیستری لیسنرها برای پاکسازی هنگام wire:navigate.
//
// قبلا این پچ داخل هندلر livewire:navigated نصب می‌شد؛ یعنی بعد از هر
// ناوبری یک لایهٔ wrapper تازه روی addEventListener اضافه می‌شد (بعد از
// N ناوبری، N تابع تودرتو روی هر ثبت لیسنر در کل صفحه) و آرایه‌های reg
// قدیمی هیچ‌وقت خالی نمی‌شدند و نودهای DOM را زنده نگه می‌داشتند.
//
// رفتار این نسخه دقیقا همان است — پنجرهٔ ردیابی از هر livewire:navigated
// شروع می‌شود و removeAllListeners همان مجموعه را پاک می‌کند — ولی فقط
// یک بار پچ می‌شود و همان آرایه بازاستفاده می‌شود.
(function () {
  if (window.__listenerRegistryInstalled) {
    return;
  }
  window.__listenerRegistryInstalled = true;

  const reg = [];
  let tracking = false;
  const origAdd = EventTarget.prototype.addEventListener;

  EventTarget.prototype.addEventListener = function (type, listener, opts) {
    if (tracking) {
      reg.push({ target: this, type, listener, opts });
    }
    return origAdd.call(this, type, listener, opts);
  };

  // متد کمکی جهانی:
  window.removeAllListeners = function () {
    for (let i = reg.length - 1; i >= 0; i--) {
      const { target, type, listener, opts } = reg[i];
      try { target.removeEventListener(type, listener, opts); } catch {}
    }
    reg.length = 0;
  };

  document.addEventListener('livewire:navigated', () => {
    reg.length = 0;
    tracking = true;
  });
})()

import "./layouts/header/desktop-navigation.js"
import "./layouts/header/games-mega-tabs.js"
import "./layouts/header/mobile-navigation.js"
import "./layouts/header/header-scroll.js"
import "./layouts/toast.js"
import "./layouts/hover.js"
import "./layouts/dialogable.js"
import "./layouts/header/header-dropdowns.js"
import "./layouts/theme-switcher.js"
// import './layouts/chat.js'

import './layouts/icon-loader.js'
// import './layouts/wire-navigating.js'
import "./layouts/initText2.js"


import "./layouts/layouts.js"

import { loadStories } from "./components/stories-loader.js"
loadStories()

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(function (registration) {
    }).catch(function (error) {

    }
  );
}

addClickHandler(".faq_question", function (event) {
  let question = event.target.closest(".faq_question");
  if (!question || !question.id) {
    return;
  }

  let id = question.id.replace("question_", "");
  let answer = document.getElementById("answer_" + id);
  let faqItem = question.closest('.faq-item');

  if (answer && faqItem) {
      // Close all other FAQs first
      document.querySelectorAll('.faq_question').forEach(function(otherQuestion) {
        if (otherQuestion.id !== question.id) {
          let otherId = otherQuestion.id.replace("question_", "");
          let otherAnswer = document.getElementById("answer_" + otherId);
          let otherFaqItem = otherQuestion.closest('.faq-item');

          if (otherAnswer && otherFaqItem) {
            otherAnswer.classList.remove("active", "show");
            otherQuestion.classList.remove("active");
            otherFaqItem.classList.remove("active");
          }
        }
      });

      if (answer.classList.contains("active")) {
        answer.classList.remove("active", "show");
        question.classList.remove("active");
        faqItem.classList.remove("active");
      } else {
        answer.classList.add("show", "active");
        question.classList.add("active");
        faqItem.classList.add("active");
      }
  }
})

/*end faq*/

// Black Friday Countdown Timer - تا جمعه شب (پس فردا) ساعت 23:59:59
function updateBlackFridayCountdown() {
  const countdownElement = document.getElementById('blackFridayCountdown');
  if (!countdownElement) return;

  // تاریخ امروز
  const now = new Date();

  // استفاده از تاریخ پایان از سرور (اگر موجود باشد) یا محاسبه از امروز
  let endDate;
  if (window.blackFridayEndDate) {
    // استفاده از تاریخ سرور
    endDate = new Date(window.blackFridayEndDate);
  } else {
    // محاسبه از امروز: جمعه (2 روز بعد - پس فردا)
    endDate = new Date();
    endDate.setDate(now.getDate() + 2);
    // تنظیم ساعت روی 23:59:59 جمعه شب
    endDate.setHours(23, 59, 59, 999);
  }

  const endTime = endDate.getTime();
  const currentTime = now.getTime();
  const distance = endTime - currentTime;

  if (distance < 0) {
    countdownElement.innerHTML = '<div class="black-friday-badge">فروش به پایان رسید</div>';
    return;
  }

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  const daysElement = document.getElementById('days');
  const hoursElement = document.getElementById('hours');
  const minutesElement = document.getElementById('minutes');
  const secondsElement = document.getElementById('seconds');

  if (daysElement) daysElement.textContent = String(days).padStart(2, '0');
  if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
  if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
  if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
}

// شروع countdown timer برای Black Friday
function initBlackFridayCountdown() {
  if (document.getElementById('blackFridayCountdown')) {
    updateBlackFridayCountdown();
    setInterval(updateBlackFridayCountdown, 1000);
  }
}

// اجرا بعد از لود شدن DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlackFridayCountdown);
} else {
  initBlackFridayCountdown();
}

// برای Livewire navigation
document.addEventListener('livewire:navigated', initBlackFridayCountdown);

// // Black Friday Loader - Lazy Loading
// (function() {
//   // URL تصویر از window گرفته می‌شود یا از مسیر نسبی استفاده می‌کند
//   const loaderGifUrl = window.blackFridayLoaderGifUrl || '/files/app/black-friday-loader.gif';
//   let listenerAttached = false;
//
//   function createLoaderHTML() {
//     return `
//       <a href="/black-friday" class="black-friday-loader-link">
//         <img
//           src="${loaderGifUrl}"
//           alt="Black Friday"
//           class="black-friday-loader-gif"
//           loading="lazy"
//         />
//       </a>
//       <button
//         class="black-friday-loader-close"
//         onclick="if(typeof window.closeBlackFridayLoader === 'function') { window.closeBlackFridayLoader(event); } return false;"
//         aria-label="بستن"
//         title="بستن"
//         type="button"
//       >
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
//           <line x1="18" y1="6" x2="6" y2="18"></line>
//           <line x1="6" y1="6" x2="18" y2="18"></line>
//         </svg>
//       </button>
//     `;
//   }
//
//   function closeBlackFridayLoader(event) {
//     if (event) {
//       event.preventDefault();
//       event.stopPropagation();
//       event.stopImmediatePropagation();
//     }
//
//     const loader = document.getElementById('blackFridayLoader');
//     if (loader) {
//       loader.style.display = 'none';
//       loader.innerHTML = '';
//
//       const hideUntil = Date.now() + (5 * 60 * 1000);
//       localStorage.setItem('blackFridayLoaderHideUntil', hideUntil.toString());
//     }
//     return false;
//   }
//
//   function attachCloseButtonListener() {
//     if (listenerAttached) return;
//
//     const loader = document.getElementById('blackFridayLoader');
//     if (loader) {
//       listenerAttached = true;
//       loader.addEventListener('click', function(e) {
//         if (e.target.closest('.black-friday-loader-close')) {
//           e.preventDefault();
//           e.stopPropagation();
//           e.stopImmediatePropagation();
//           closeBlackFridayLoader(e);
//         }
//       }, true);
//     }
//   }
//
//   function checkAndShowLoader() {
//     const loader = document.getElementById('blackFridayLoader');
//     if (!loader) return;
//
//     const hideUntil = localStorage.getItem('blackFridayLoaderHideUntil');
//
//     if (hideUntil) {
//       const hideUntilTime = parseInt(hideUntil);
//       const now = Date.now();
//
//       if (now < hideUntilTime) {
//         loader.style.display = 'none';
//         const timeLeft = hideUntilTime - now;
//         setTimeout(function() {
//           initLoader();
//         }, timeLeft);
//         return;
//       } else {
//         localStorage.removeItem('blackFridayLoaderHideUntil');
//       }
//     }
//
//     if (loader.innerHTML.trim() === '') {
//       loader.innerHTML = createLoaderHTML();
//       setTimeout(function() {
//         attachCloseButtonListener();
//       }, 10);
//     }
//
//     loader.style.display = 'flex';
//   }
//
//   function initLoader() {
//     if (document.readyState === 'loading') {
//       document.addEventListener('DOMContentLoaded', function() {
//         window.addEventListener('load', function() {
//           setTimeout(checkAndShowLoader, 100);
//         });
//       });
//     } else {
//       if (document.readyState === 'complete') {
//         setTimeout(checkAndShowLoader, 100);
//       } else {
//         window.addEventListener('load', function() {
//           setTimeout(checkAndShowLoader, 100);
//         });
//       }
//     }
//   }
//
//   window.closeBlackFridayLoader = closeBlackFridayLoader;
//
//   initLoader();
//
//   document.addEventListener('livewire:init', function() {
//     setTimeout(checkAndShowLoader, 100);
//   });
//   document.addEventListener('livewire:navigated', function() {
//     setTimeout(checkAndShowLoader, 100);
//   });
// })();




